import type { EventFilter } from '@tc8l/nuxt-overview'

export function useFilterHelpers() {
  /**
   * Check if a filter has any active/selected options
   */
  function hasActiveFilters(filter: EventFilter) {
    return filter.options.some((o: { isSelected?: boolean }) => o.isSelected)
  }

  /**
   * Clear all selected options for a specific filter
   */
  function clearFilterSelection(filter: EventFilter, clearFilterValue: (value: string, idx?: number) => void) {
    clearFilterValue(filter.value, filter.idx)
  }

  /**
   * Get all currently selected filter options as an array of objects
   */
  function getSelectedFilterObjects(availableFilters: EventFilter[]) {
    const items: { key: string; label: string; filter: EventFilter; option: EventFilter }[] = []

    availableFilters.forEach((f) => {
      f.options.forEach((o) => {
        if (o.isSelected) {
          items.push({
            key: `${f.value}-${o.id}`,
            label: o.label,
            filter: f,
            option: o,
          })
        }
      })
    })
    return items
  }

  return {
    hasActiveFilters,
    clearFilterSelection,
    getSelectedFilterObjects,
  }
}
